import { CustomerDetailFullAccount } from '../types';

export const withdrawalJudicialBlockReasonId = '9';
export const withdrawalJudicialBlockTooltipMessage = 'Bloqueio judicial - Saque inativo';
export const withdrawalCheckErrorTooltipMessage = 'Saque inativo.';

export type WithdrawalEligibility = {
  isBlocked: boolean;
  tooltipMessage?: string;
};

export const getWithdrawalEligibility = (
  customer: CustomerDetailFullAccount | null | undefined,
  isLoading: boolean,
  hasError: boolean
): WithdrawalEligibility => {
  if (isLoading || hasError || !customer) {
    return { isBlocked: true };
  }

  if (customer.pendingRegistrationCheckError) {
    return { isBlocked: true, tooltipMessage: withdrawalCheckErrorTooltipMessage };
  }

  const hasJudicialBlock = customer.pendingRegistrationReasons
    .flatMap((group) => group.reasons)
    .some((reason) => reason.id === withdrawalJudicialBlockReasonId);

  if (hasJudicialBlock) {
    return { isBlocked: true, tooltipMessage: withdrawalJudicialBlockTooltipMessage };
  }

  return { isBlocked: false };
};
